<div class="container">
    <div class="card flat">
        <div class="card-body">
            <h5 class="card-title">Build Your Audience</h5>
            <div class="row">
                <div class="col-6">
                    <!-- <a (click)="goNewInBooks()">
                        <div class="subcard">
                            <div class="subcard-header bg-black">
                                <img src="../../../assets/img/home/widgets/new-in-books.png" alt="">
                            </div>
                            <div class="subcard-body">
                                <div class="subcard-body-container">
                                    <p class="subcard-body-container-text">Generate buzz and get reviews for your new release.</p>
                                    <a class="button-action button-black" (click)="goNewInBooks()">Reserve My Date</a>
                                </div>
                            </div>
                        </div>
                    </a> -->

                    <a routerLink="/features/reader-reach-lead-magnet" class="rr-tile">
                        <span class="rr-logo">
                            <img 
                                src="https://storage.googleapis.com/wwm-static-content/Reader-Reach-Lead-Magnet----Stacked---Full-Color-BETA.png" 
                                alt=""
                            >
                        </span>
                        <span class="rr-body">
                            <span class="rr-title">Reader Reach Lead Magnets</span>
                            <span class="rr-copy">Have us do all the work and run a lead magnet campaign.</span>
                            <span class="rr-btn">Run a Lead Magnet</span>
                        </span>
                    </a>
                </div>

                <div class="col-6">
                    <a (click)="goGiveaways()">
                        <div class="subcard bg-yellow">
                            <div class="subcard-header">
                                <img src="../../../assets/img/features/sites/ssg-tile-header.svg" alt="">
                            </div>
                            <div class="subcard-body">
                                <div>
                                    <div class="subcard-body-container-image">
                                        <img src="../../../assets/img/home/widgets/giveaways.png" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div class="subcard-body-container">
                                        <h6 class="subcard-body-container-title">Grow your Email List</h6>
                                        <p class="subcard-body-container-text">
                                            Add engaged readers to your author newsletter by joining a Giveaway.
                                        </p>
                                        <a class="button-action button-yellow" (click)="goGiveaways()">Join a Giveaway</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
